import React from "react";
import "../App.css";
import { Button } from "./Button";
import "./HeroSection.css";
import Typed from "react-typed";
import { Link } from "react-scroll";

function HeroSection() {
  return (
    <div>
      <div id="header"></div>
      <div className="hero-container" id="hero">
        <video src="/videos/video-4.mp4" autoPlay loop muted />
        <h1>HELLO! </h1>
        <h2>I'M JOHANNES KGATLE</h2>
        <p>
          <Typed
            className="typed-text"
            strings={[
              "{COMPUTER SCIENCE}",
              "{",
              "{WEB DESIGN}",
              "{WEB DEVELOPMENT}",
            ]}
            typeSpeed={80}
            backSpeed={80}
            loop
          />
        </p>
        <div className="hero-btns">
          <Link
            to="work"
            activeClass="active"
            spy={true}
            smooth={true}
            duration={1000}
          >
            <Button
              className="btns"
              buttonStyle="btn--outline"
              buttonSize="btn--large"
            >
              VIEW MY WORK <i className="far fa-play-circle" />
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default HeroSection;
